import _defineProperty from "/builds/frontend/deemo-official/deemo2-official-new/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isObject, isScrollBehaviorSupported, modifyPrototypes, original } from "./common.js";
import { elementScroll } from "./Element.scroll.js";
export { elementScroll as elementScrollTo } from "./Element.scroll.js";
export var elementScrollToPolyfill = function elementScrollToPolyfill(animationOptions) {
  if (isScrollBehaviorSupported()) {
    return;
  }

  var originalFunc = original.elementScroll;
  modifyPrototypes(function (prototype) {
    return prototype.scrollTo = function scrollTo() {
      if (arguments.length === 1) {
        var scrollToOptions = arguments[0];

        if (!isObject(scrollToOptions)) {
          throw new TypeError("Failed to execute 'scrollTo' on 'Element': parameter 1 ('options') is not an object.");
        }

        var left = Number(scrollToOptions.left);
        var top = Number(scrollToOptions.top);
        return elementScroll(this, _objectSpread(_objectSpread({}, scrollToOptions), {}, {
          left: left,
          top: top
        }, animationOptions));
      }

      return originalFunc.apply(this, arguments);
    };
  });
};